import React from "react";
import { position, PositionProps } from "styled-system";

import { Box } from "@bca/ui-library";
import styled from "styled-components";

const LotBox = styled(Box)`
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 9px 0 rgba(65, 65, 65, 0.1);
  text-transform: uppercase;
  background-color: rgba(255, 255, 255, 0.3);
  ${position}
`;

interface LotProps extends PositionProps {
  lotNumber: string;
}

function LotNumber({ lotNumber, ...props }: LotProps) {
  return (
    <LotBox
      minHeight={25}
      padding="6px 10px"
      color="primary-white"
      mt={[2, 3]}
      {...props}
    >
      {lotNumber}
    </LotBox>
  );
}

export default LotNumber;
